<template>
  <div class="footer">
    <p class="footer__text">
      <app-i18n code="teamRegistrationSite.footer" />
      <span v-text="' '" />
      <a
        class="footer__text__link"
        :href="mailHref"
        target="_blank"
        v-text="email"
      />
    </p>
  </div>
</template>

<script>
export default {
  name: 'appFooter',
  data() {
    return {
      email: 'hello@owqlo.com'
    }
  },
  computed: {
    mailHref() {
      return `mailto:${this.email}`
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.5);
  background-color: #404040;
  text-align: center;

  &__text {
    font-size: 12px;
    color: #ffffff;

    &__link {
      font-weight: 600;
      color: #2acccc;
    }
  }
}
</style>